export const tableHeader = (t) => [
  {
    id: 'id',
    type: 'text',
    value: t('cookies:page.table.id'),
  },
  {
    id: 'url',
    type: 'text',
    value: t('cookies:page.table.site'),
  },
  {
    id: 'action',
    type: 'actions',
    value: '',
  },
]
